import React,{useState} from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v';

const getLocalData = () => {
  const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
  return data !== null ? JSON.parse(data) : null;
};

export function MenuInner() {

  const localData = getLocalData();

  const [openSearch,setOpenSearch] = useState(false)
  const [searchLoading,setSearchLoading] = useState(false)
  const [search,setSearch] = useState("")
  const [searchResult, setSearchResult] = useState<any>(null);

  const API_URL = process.env.REACT_APP_API_URL;
  const SEARCH_URL = `${API_URL}/user/advanced-search`;

  const searchSubmit = async () => {
    if(search != ""){
    setOpenSearch(true)
    setSearchLoading(true);
    const config = {
      headers: { Authorization: `Bearer ${localData.api_token}` }
    };
    const query = {
      search:search
    }
    await axios.post(SEARCH_URL,query,config)
      .then((response) => {
        setSearchResult(response.data.data);
        console.log(response.data.data)
        setSearchLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setSearchLoading(false);
        setOpenSearch(false)
      });

      }
  };

  const cancelSearch = ()=>{
    setOpenSearch(false)
    setSearchLoading(false)
    setSearchResult(null)
    setSearch("")
  }

  const getTodayDate = () => {

    // const getGreeting = () => {
    //   const date = new Date();
    //   const options = { timeZone: 'America/Los_Angeles' };
    //   const formattedDate = date.toLocaleString('en-US', options);
    //   const hours = new Date(formattedDate).getHours();
    //   let greeting = "";

    //   if (hours >= 0 && hours < 12) {
    //     greeting = "GOOD MORNING TODAY –";
    //   } else if (hours >= 12 && hours < 17) {
    //     greeting = "GOOD AFTERNOON TODAY –";
    //   } else {
    //     greeting = "GOOD EVENING TODAY –";
    //   }

    //   return greeting;
    // };

    const monthArray = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const date = new Date();
    const todayDate = date.getDate();
    var daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var dayOfWeek = daysOfWeek[date.getDay()];
    return (
      <span>
        {/* {getGreeting()} */}
        <span style={{ color: "#2a2727ff", marginLeft: "5px" }}>
          {dayOfWeek},&nbsp;
          {monthArray[date.getMonth()]}&nbsp;
          {todayDate.toString().length > 1 ? todayDate : "0" + todayDate}
          <sup>{todayDate === 1 && "st"}{todayDate === 2 && "nd"}{todayDate === 3 && "rd"}{todayDate > 3 && "th"}</sup>&nbsp;
          {date.getFullYear()}
        </span>
      </span>
    );
  };

  return (
    <>
      {/* <h2 className='text-gray-700' style={{ marginTop: "20px" }}>Welcome, {localData?.first_name} {localData?.last_name}<br /><span className='fs-6 text-gray-700' style={{fontWeight:'400'}}>{localData?.user_no}</span></h2>&nbsp;&nbsp;&nbsp; */}
      <div className='position-relative'>
        <div className="form-group d-flex">
        <input type="search" placeholder='Tracking Search..' className='bg-gray-200' value={search} onChange={(e)=> setSearch(e.target.value)}  
        style={{padding:'10px 20px',border:'none',borderRadius:'10px 0 0 10px'}}/>
        {openSearch ? (
          <button className='bg-gray-200' onClick={cancelSearch} style={{padding:'10px 15px',border:'none',borderRadius:'0 10px 10px 0'}}><i className="fas fa-close"></i></button>
        ) : (
          <button className='bg-gray-200' onClick={searchSubmit} style={{padding:'10px 15px',border:'none',borderRadius:'0 10px 10px 0'}}><i className="fas fa-search"></i></button>
        )}
        
      </div>
      {openSearch && (
      <div className="search-results card card-body shadow position-absolute top-5 left-5" style={{width:400}}>
          {!searchLoading ? (
            <>
            {(searchResult != null) ? (
              <>
              {searchResult?.tracking && (
                // <Link to={'/tracking'} state={{id:searchResult?.tracking.id,query:searchResult?.tracking.tracking_no}}>
                <div className="tracking-item d-flex justify-content-between">
                <div>
                  <h5>{searchResult.tracking?.tracking_no}</h5>
                  <h6 className='text-secondary'>{searchResult.tracking?.order_no}</h6>
                </div>
                <div>
                  {searchResult.statement ? (
                    <>
                      {searchResult.tracking_statement ? (
                        <h5 className='text-success'>${searchResult.tracking_statement?.price.toFixed(2)}</h5>
                      ) : (
                        <h5 className='text-success'>${searchResult.statement?.price.toFixed(2)}</h5>
                      )}
                    </>
                  ) : (
                    <h5 className='text-success'>${searchResult?.tracking_price.toFixed(2)}</h5>
                  )}
                  
                  
                  {searchResult.tracking?.status == 0 && (
                    <span className='badge badge-success'>Accepted</span>
                  )}
                  {searchResult.tracking?.status == 1 && (
                    <span className='badge badge-warning'>Pending</span>
                  )}
                  
                </div>
              </div>
                // </Link>
              )}
              
              {searchResult?.statement && (
                <Link to={'/statements'} state={{id:searchResult?.statement.id,query:searchResult?.statement.statement_no}}>
                <div className="border-bottom my-3"></div>
                <div className="tracking-item d-flex justify-content-between">
                <div>
                  <h5>{searchResult.statement?.statement_no}</h5>
                  <h6 className='text-secondary'>{searchResult.tracking?.tracking_no}</h6>
                </div>
                <div>
                  <h5 className='text-success'>${searchResult.statement?.price.toFixed(2)}</h5>
                  {searchResult.statement?.payment_status == 1 && (
                    <span className='badge badge-primary'>Paid</span>
                  )}
                  {searchResult.statement?.payment_status == 2 && (
                    <span className='badge badge-primary'>Paid</span>
                  )}
                  {searchResult.statement?.payment_status == 3 && (
                    <span className='badge badge-warning'>Partial Paid</span>
                  )}
                  {searchResult.statement?.payment_status == 0 && (
                    <span className='badge badge-success'>Active</span>
                  )}
                  
                </div>
              </div>
                </Link>
              )}
              {searchResult?.withdraw && (
                <Link to={'/withdraws'} state={{id:searchResult?.withdraw.id,query:searchResult?.withdraw.withdraw_no}}>
                <div className="border-bottom my-3"></div>
                <div className="tracking-item d-flex justify-content-between">
                <div>
                  <h5>{searchResult.withdraw?.withdraw_no}</h5>
                  <h6 className='text-secondary'>{searchResult.statement?.statement_no}</h6>
                </div>
                <div>
                  <h5 className='text-success'>${searchResult.withdraw?.payment.toFixed(2)}</h5>
                  {searchResult.statement?.payment_status == 1 && (
                    <span className='badge badge-primary'>Paid</span>
                  )}
                </div>
              </div>
                </Link>
              )}
              </>
            ) : (
              <h5>No Data Found!</h5>
            )}
            </>
          ) : (
            <h5>Loading...</h5>
          )}
      </div>
      )}
      </div>
      <div className="bg-gray-200" style={{borderRadius:'10px',padding:'5px 40px',marginLeft:20}}>
        <h3 className='fs-5 text-gray-700' style={{ marginTop: "5px" }}><span>{getTodayDate()}</span></h3>
      </div>
      {/* 
      <MenuItem title={intl.formatMessage({id: 'DASHBOARD'})} to='/dashboard' />
      <MenuItem title='Layout Builder' to='/builder' /> */}
      {/* <MenuInnerWithSub
        title='Crafted'
        to='/crafted'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        <MenuInnerWithSub
          title='Pages'
          to='/crafted/pages'
          fontIcon='bi-archive'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuInnerWithSub
            title='Profile'
            to='/crafted/pages/profile'
            hasArrow={true}
            hasBullet={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
            <MenuItem
              to='/crafted/pages/profile/connections'
              title='Connections'
              hasBullet={true}
            />
          </MenuInnerWithSub>
          <MenuInnerWithSub
            title='Wizards'
            to='/crafted/pages/wizards'
            hasArrow={true}
            hasBullet={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to='/crafted/pages/wizards/horizontal' title='Horizontal' hasBullet={true} />
            <MenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
          </MenuInnerWithSub>
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Accounts'
          to='/crafted/accounts'
          fontIcon='bi-person'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
          <MenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Errors'
          to='/error'
          fontIcon='bi-sticky'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/error/404' title='Error 404' hasBullet={true} />
          <MenuItem to='/error/500' title='Error 500' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Widgets'
          to='/crafted/widgets'
          fontIcon='bi-layers'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
          <MenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
          <MenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
          <MenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
          <MenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
          <MenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
        </MenuInnerWithSub>
      </MenuInnerWithSub> */}

      {/* <MenuInnerWithSub title='Apps' to='/apps' menuPlacement='bottom-start' menuTrigger='click'>
        <MenuInnerWithSub
          title='Chat'
          to='/apps/chat'
          icon='message-text-2'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
          <MenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
          <MenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
        </MenuInnerWithSub>
        <MenuItem icon='abstract-28' to='/apps/user-management/users' title='User management' />
      </MenuInnerWithSub> */}

      {/* <MenuInnerWithSub
        isMega={true}
        title='Mega menu'
        to='/mega-menu'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        <MegaMenu />
      </MenuInnerWithSub> */}
    </>
  );
};
